import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import AssetLayout from './components/AssetLayout'
import List from './components/List'
import Detail from './components/Detail'
import Create from './components/Create'

const AssetModule: RouteObject = {
    path: 'assets',
    element: <AssetLayout />,
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: 'new',
            element: <Create />,
        },
        {
            path: ':id',
            element: <Detail />,
        },
        {
            path: ':id/edit',
            element: <Create />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default AssetModule
